/** @format */

import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconSignCancel
} from '@dsg-tech/homefield-angular-icons';

@Component({
	selector: 'product-reviews-chips',
	templateUrl: './review-chips.component.html',
	styleUrl: './review-chips.component.scss',
	imports: [HomefieldIconLibraryModule, CommonModule]
})
export class ReviewChipsComponent {
	@Input() label = '';
	@Input() displayCancelSign = false;
	@Input() isSelected = false;
	@Input() displayChip = true;
	@Output() chipClicked: EventEmitter<unknown> = new EventEmitter();
	private readonly homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);

	constructor() {
		this.homefieldIconsLibraryService.registerIcons([homefieldIconSignCancel]);
	}

	actionClicked() {
		this.chipClicked.emit(null);
	}
}
